<template>
  <a
    :class="[extraClasses, disabledClasses]"
    class="sf-btn"
    data-walkthrough-id="new-remark-button"
    @click="openModal"
    @mousedown="saveSelection"
    >{{ I18n.t('communication.add_remark') }}</a
  >
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { useStore } from 'vuex'

import { isCurrentWorkflowLocked } from '@app/adapters/silverfin'
import { stringToQuote } from '@app/utils/string-helpers'

import { useWorfklowReviewItems } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-items'

defineOptions({
  name: 'NewRemarkButton',
})

const props = defineProps({
  ownerType: String,
  ownerId: [String, Number],
  ledgerId: [String, Number],
  ledgerLabel: String,
  extraClasses: String,
  showTags: {
    type: Boolean,
    default: true,
  },
})

const selectedText = ref(null)
const store = useStore()

const workflowReviewItemsStore = useWorfklowReviewItems()
const { currentReviewItem } = storeToRefs(workflowReviewItemsStore)

const disabled = isCurrentWorkflowLocked()

const disabledClasses = disabled ? ['sf-btn-disabled'] : []

const allRemarkTags = computed(
  () => store.state?.remarkTags?.allRemarkTags || {}
)

const remarkContext = computed(() => {
  const newRemarkText = stringToQuote(selectedText.value)

  return {
    ownerType: effectiveOwnerType.value,
    ownerId: effectiveOwnerId.value,
    ledgerId: props.ledgerId,
    ledgerLabel: props.ledgerLabel,
    text: newRemarkText,
    allRemarkTags: allRemarkTags.value,
    showTags: props.showTags,
  }
})

// For workflow review items, we have to use the itemClass and item id instead as context values
// This happens because account entry workflow review items have a contextType of 'account' and an itemClass of 'account_entry'.
// The communication only works with an ownerType of 'account_entry' for them.
// If the values are not set outright to something it means we are in the Workflow Review page.
const effectiveOwnerType = computed(() => {
  return props.ownerType || currentReviewItem.value.itemClass
})

const effectiveOwnerId = computed(() => {
  return props.ownerId || currentReviewItem.value.id
})

const openModal = (payload = {}) => {
  window.modalCitizen.openModal('new-remark', {
    ...remarkContext.value,
    ...payload,
  })
}

const saveSelection = () => {
  selectedText.value = window.getSelection().toString()
}

onMounted(() => {
  window.eventHub.$on('openNewRemarkModal', openModal)
})

onBeforeUnmount(() => {
  window.eventHub.$off('openNewRemarkModal', openModal)
})
</script>
